<div class="header">
    <h2 translate>watch.strava_sections.title</h2>
</div>

<div class="content">
    <div class="wrapper" *ngFor="let sectionStrava of sectionsStrava ; let last  = last">
        <strava-sections-element [stravaSection]="sectionStrava" [isSmall]="xSmallScreen"></strava-sections-element>
        <div class="divider" *ngIf="!last"></div>
    </div>
</div>